module.exports = __webpack_public_path__ + "static/media/005 I GUERRA M_Stazione Ferroviaria.285868ca.svg";